// eslint-disable-next-line no-restricted-syntax
export enum FacilityRoles {
  ADMIN = "ADM",
  SHIFT_MANAGEMENT = "SFT",
  INVOICES = "INV",
  DOCUMENTS = "DMT",
  RECRUITMENT = "REC",
  CORPORATE_ADMIN = "CORP",
}

// eslint-disable-next-line no-restricted-syntax
export enum FacilityUserPermissions {
  POST_SHIFT_PERMISSION = "post-shifts",
  CANCEL_SHIFT_PERMISSION = "cancel-shifts",
  MANAGE_INVOICES = "manage-invoices",
  ACCESS_UPCOMING_CHARGES = "access-upcoming-charges",
  ACCESS_CONTRACT_TERMS = "access-contract-terms",
  SEE_CHARGE_RATES = "see-charge-rates",
  DISPUTE_UPCOMING_CHARGES = "dispute-upcoming-charges",
  EDIT_SHIFT_RATE = "edit-shift-rate",
  REVIEW_EXTRA_TIME_PAYMENT_REQUESTS = "review-extra-time-payment-requests",
  SET_IN_HOME_VISIT_RATE = "set-in-home-visit-rate",
  MANAGE_CHARTING = "manage-charting",
  ADD_DNR = "add-dnr",
  REMOVE_DNR = "remove-dnr",
  ACCESS_REPORTING = "access-reporting",
}
